import React from "react";

export default function Header({ onHome, onContact }) {
  return (
    <header data-testid="app-header" className="sticky top-0 z-40 border-b border-white/10 bg-background/40 backdrop-blur-md">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        {/* Left: X icon (home) */}
        <button
          type="button"
          onClick={onHome}
          data-testid="btn-home"
          aria-label="Startseite"
          className="inline-flex items-center justify-center w-11 h-11 rounded-full hover:opacity-100 opacity-95 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <img
            src="/xortec/xicon-white.webp"
            alt="Xortec"
            className="w-10 h-10 object-contain"
          />
        </button>

        {/* Right cluster */}
        <div className="flex items-center gap-3">
          {onContact && (
            <button
              type="button"
              onClick={onContact}
              data-testid="btn-header-contact"
              className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-white/25 bg-white/5 hover:border-primary/60 hover:text-primary text-sm text-white transition-colors"
            >
              Kontakt
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
